import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from './engagement-bar-leads-empty-state.module.css';

interface Props {
    hasFilters: boolean;
    onRemoveFilters: () => void;
}

export const EngagementBarLeadsEmptyState = (props: Props) => {
    return (
        <div className={`text-align-center ${styles['empty-state-container']}`}>
            <Stack alignItems='center' justifyContent='center' spacing={16}>
                <Illustration src='engagement-bar' width={200} />
                <Body isBold={true}>
                    {props.hasFilters
                        ? 'We couldn’t find anything with those filters.'
                        : 'There are currently no leads'}
                </Body>
                {props.hasFilters ? (
                    <Link variant='primary' size='small' onClick={props.onRemoveFilters}>
                        Remove filters
                    </Link>
                ) : (
                    <Body color='light' size='small'>
                        Here, you’ll find all active leads generated from the engagement bar actions
                        you configure.
                    </Body>
                )}
            </Stack>
        </div>
    );
};
